<template lang="jade">
  lightbox(":open"="open"
           ":loading"="loading")
    div.Lightbox__body(slot="Lightbox__body")
      workflow-set(":wid"="wid" ":sid"="sid" ":params"="params" ":dynamic"="dynamic")
</template>

<script>
  import _ from 'lodash'
  import { removeDynamicWorkflow,
           clearAllDynamicWorkflows } from 'src/vuex/actions'
  import set from 'src/components/workflows/set'
  import lightbox from 'src/components/dialogs/lightbox'

  export default {
    data () {
      return { open: true,
               uid: null,
               dynamic: true,
               loading: true,
               prompt: false,
               fragment: [],
               loginSchema: require('src/components/forms/_data/login.json') }
    },
    props: {
      id: { type: String,
            required: true },
      wid: { type: String,
             required: true },
      params: { type: Object },
      sid: { type: String },
      readonly: { type: Boolean }
    },

    components: {
      lightbox,
      'workflow-set': set
    },

    vuex: {
      actions: {
        removeDynamicWorkflow,
        clearAllDynamicWorkflows
      }
    },

    events: {
      'closed': 'destroy',
      'state::loading' () {
        setTimeout(() => { this.$set('loading', false) }, 1000)
      }
    },
    methods: {
      destroy () {
        const index = _.findIndex(this.dynamicWorkflows, ['id', this.id])
        this.removeDynamicWorkflow(index)
        this.$destroy()
      }
    },

    created () {
      // setTimeout(() => { this.$set('loading', false) }, 1000)
    }
  }
</script>



// WEBPACK FOOTER //
// dynamic.vue?258f43ae